<template>
  <div class="sort-dropdown">
    <el-select v-model="selected" placeholder="Filter by Genre" @change="handleChange">
			<el-option :label="option" :value="option" v-for='option in options' :key='option'>
				{{ option }}
			</el-option>
    </el-select>
  </div>
</template>

<script>
import { getLocalStorage } from '../app/helpers';
export default {
	props: {
		onChange: Function,
		active: String
	},

  data() {
    return {
			selected: "",
			options: []
    };
	},
	
	mounted(){
		if (this.active) {
			this.selected = this.active;
		}

		this.options = getLocalStorage('genres', []);
	},


	methods: {
		handleChange() {
			if (this.onChange) {
				this.onChange(this.selected);
			}
		}
	},

  watch: {
    selected() {}
  }
};
</script>